<template>
  <div class="data-update-log-detail">
    <div>{</div>
    <ul style="overflow:auto">
      <li v-for="(item, index) in detail" :key="index">
        <span style="margin-left: 20px" v-html="item.content" />
      </li>
    </ul>
    <div>}</div>
  </div>
</template>

<script>
export default {
  name: 'DataUpdateLogDetail',
  props: {
    detail: { type: Array, default: () => [] } // 是否隐藏
  }
}
</script>
<style lang="scss">
.data-update-log-detail {
  ul {
    list-style-type: none;
    padding: 0;
    margin: 5px;
    li {
      margin: 10px;
    }
  }
}
</style>
